(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spx-app-guard')) {
    customElements.define(
      'spx-app-guard',
      class SpxAppGuard extends HTMLElement {
        connectedCallback() {
          if (window.Shopify && window.Shopify.designMode) return;
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              this.watch();
            },
            { rootMargin: '300px 0px' }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          clearInterval(this.timer);
        }

        hasContent() {
          const blocks = this.querySelectorAll('.shopify-app-block');
          const hasText = [...blocks].some((block) => block.innerText.trim().length > 0);
          const hasMedia = [...this.querySelectorAll('video, img')].some(
            (media) => media.readyState >= 1 || (media.complete && media.naturalWidth > 0)
          );
          return hasText || hasMedia;
        }

        watch() {
          const started = Date.now();
          this.timer = setInterval(() => {
            if (this.hasContent()) {
              clearInterval(this.timer);
              return;
            }
            if (Date.now() - started > 8000) {
              clearInterval(this.timer);
              const section = this.closest('.shopify-section');
              (section || this).hidden = true;
            }
          }, 500);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    const STORAGE_KEY = 'spx-filters-hidden';

    const readPreference = () => {
      try {
        return localStorage.getItem(STORAGE_KEY) === '1';
      } catch (error) {
        return false;
      }
    };

    const savePreference = (hidden) => {
      try {
        localStorage.setItem(STORAGE_KEY, hidden ? '1' : '0');
      } catch (error) {
        /* private mode: the choice just isn't remembered */
      }
    };

    const apply = (hidden) => {
      document.querySelectorAll('.facets-vertical').forEach((element) => {
        element.classList.toggle('spx-filters-hidden', hidden);
      });
      document.querySelectorAll('[data-spx-filter-toggle]').forEach((button) => {
        button.setAttribute('aria-expanded', String(!hidden));
        button.querySelector('[data-label-hide]').hidden = hidden;
        button.querySelector('[data-label-show]').hidden = !hidden;
      });
    };

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-spx-filter-toggle]')) return;
      const grid = document.querySelector('.facets-vertical');
      const next = !(grid && grid.classList.contains('spx-filters-hidden'));
      savePreference(next);
      apply(next);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => apply(readPreference()));
    } else {
      apply(readPreference());
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spx-tabs')) {
    customElements.define(
      'spx-tabs',
      class SpxTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index));
            tab.addEventListener('keydown', (event) => {
              const last = this.tabs.length - 1;
              let next = null;
              if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
              if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = last;
              if (next === null) return;
              event.preventDefault();
              this.select(next, true);
            });
          });

          this.querySelectorAll('.spx-rail-wrap').forEach((wrap) => this.setupRail(wrap));
        }

        hydrate(panel) {
          const template = panel.querySelector(':scope > template');
          if (!template) return;
          panel.appendChild(template.content.cloneNode(true));
          template.remove();
          panel.removeAttribute('data-lazy');
          panel.querySelectorAll('.spx-rail-wrap').forEach((wrap) => this.setupRail(wrap));
        }

        select(index, focus) {
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            this.panels[i].hidden = !active;
            if (active) this.hydrate(this.panels[i]);
            if (active && focus) tab.focus();
          });
          const rail = this.panels[index].querySelector('[data-rail]');
          if (rail) rail.dispatchEvent(new Event('scroll'));
        }

        setupRail(wrap) {
          const rail = wrap.querySelector('[data-rail]');
          const prev = wrap.querySelector('[data-rail-prev]');
          const next = wrap.querySelector('[data-rail-next]');
          if (!rail || !prev || !next) return;

          const update = () => {
            prev.disabled = rail.scrollLeft <= 4;
            next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
          };
          const step = () => Math.max(rail.clientWidth * 0.85, 240);
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }));
          next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }));
          rail.addEventListener('scroll', update, { passive: true });
          window.addEventListener('resize', update, { passive: true });
          update();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spictex-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spx-header')) {
    customElements.define(
      'spx-header',
      class SpxHeader extends HTMLElement {
        connectedCallback() {
          this.lastY = window.scrollY;
          this.onScrollShadow = () => {
            const y = window.scrollY;
            this.classList.toggle('is-scrolled', y > 8);
            const mobile = window.matchMedia('(max-width: 989px)').matches;
            const menuOpen = this.menuToggle && this.menuToggle.getAttribute('aria-expanded') === 'true';
            const typing = document.activeElement && document.activeElement.matches && document.activeElement.matches('.spx-search__input');
            if (!mobile || menuOpen || typing) {
              this.classList.remove('search-hidden');
            } else if (y > 140 && y > this.lastY + 4) {
              const search = this.querySelector('.spx-search');
              this.style.setProperty('--spx-search-clip', ((search ? search.offsetHeight : 40) + 12) + 'px');
              this.classList.add('search-hidden');
            } else if (y <= 140 || y < this.lastY - 4) {
              this.classList.remove('search-hidden');
            }
            this.lastY = y;
          };
          window.addEventListener('scroll', this.onScrollShadow, { passive: true });
          this.onScrollShadow();

          this.menuToggle = this.querySelector('[data-menu-toggle]');
          this.mobileNav = this.querySelector('[data-mobile-nav]');
          this.megaItems = Array.from(this.querySelectorAll('.spx-nav__item--mega'));

          this.menuToggle?.addEventListener('click', () => this.toggleMobileNav());

          const warmTiles = () => {
            this.querySelectorAll('.spx-tile__media img[loading="lazy"]').forEach((img) => {
              img.loading = 'eager';
            });
          };
          const nav = this.querySelector('.spx-nav');
          nav?.addEventListener('pointerenter', warmTiles, { once: true });
          nav?.addEventListener('focusin', warmTiles, { once: true });

          this.megaItems.forEach((item) => {
            const toggle = item.querySelector('[data-mega-toggle]');
            toggle?.addEventListener('click', () => this.setMega(item, !item.classList.contains('is-open')));
            item.addEventListener('mouseenter', () => this.setMega(item, true));
            item.addEventListener('mouseleave', () => this.setMega(item, false, 140));
            item.addEventListener('focusout', (event) => {
              if (!item.contains(event.relatedTarget)) this.setMega(item, false);
            });
          });

          this.onKeydown = (event) => {
            if (event.key !== 'Escape') return;
            this.megaItems.forEach((item) => this.setMega(item, false));
            if (this.menuToggle?.getAttribute('aria-expanded') === 'true') {
              this.toggleMobileNav(false);
              this.menuToggle.focus();
            }
          };
          document.addEventListener('keydown', this.onKeydown);

          this.onResize = () => {
            if (window.matchMedia('(min-width: 990px)').matches) this.toggleMobileNav(false);
          };
          window.addEventListener('resize', this.onResize);
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScrollShadow);
          document.removeEventListener('keydown', this.onKeydown);
          window.removeEventListener('resize', this.onResize);
        }

        setMega(item, open, delay) {
          clearTimeout(item.spxTimer);
          const apply = () => {
            item.classList.toggle('is-open', open);
            item.querySelector('[data-mega-toggle]')?.setAttribute('aria-expanded', String(open));
            this.classList.toggle('has-mega', this.megaItems.some((el) => el.classList.contains('is-open')));
          };
          if (open) {
            this.megaItems.forEach((other) => {
              if (other !== item && other.classList.contains('is-open')) {
                clearTimeout(other.spxTimer);
                other.classList.remove('is-open');
                other.querySelector('[data-mega-toggle]')?.setAttribute('aria-expanded', 'false');
              }
            });
          }
          if (delay) item.spxTimer = setTimeout(apply, delay);
          else apply();
        }

        toggleMobileNav(force) {
          if (!this.mobileNav || !this.menuToggle) return;
          const open = typeof force === 'boolean' ? force : this.mobileNav.hidden;
          this.mobileNav.hidden = !open;
          this.menuToggle.setAttribute('aria-expanded', String(open));
          this.menuToggle.querySelector('[data-open-icon]').hidden = open;
          this.menuToggle.querySelector('[data-close-icon]').hidden = !open;
          document.body.classList.toggle('overflow-hidden', open);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spictex-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spx-chip-scroller')) {
    customElements.define(
      'spx-chip-scroller',
      class SpxChipScroller extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-scroll-track]');
          if (!this.track) return;
          this.buttons = this.querySelectorAll('[data-scroll-by]');
          this.update = this.update.bind(this);
          this.track.addEventListener('scroll', this.update, { passive: true });
          this.buttons.forEach((button) =>
            button.addEventListener('click', () => this.scrollByPage(Number(button.dataset.scrollBy)))
          );
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);
          this.setupDrag();
          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const canPrev = this.track.scrollLeft > 1;
          const canNext = this.track.scrollLeft < max - 1;
          this.toggleAttribute('data-can-prev', canPrev);
          this.toggleAttribute('data-can-next', canNext);
          this.buttons.forEach((button) => {
            button.hidden = Number(button.dataset.scrollBy) < 0 ? !canPrev : !canNext;
          });
        }

        scrollByPage(direction) {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: direction * this.track.clientWidth * 0.75, behavior: reduce ? 'auto' : 'smooth' });
        }

        setupDrag() {
          let active = false;
          let moved = false;
          let startX = 0;
          let startLeft = 0;

          this.track.addEventListener('pointerdown', (event) => {
            if (event.pointerType !== 'mouse' || event.button !== 0) return;
            active = true;
            moved = false;
            startX = event.clientX;
            startLeft = this.track.scrollLeft;
          });

          this.track.addEventListener('pointermove', (event) => {
            if (!active) return;
            const distance = event.clientX - startX;
            if (!moved && Math.abs(distance) > 5) {
              moved = true;
              this.track.setPointerCapture(event.pointerId);
              this.track.classList.add('is-dragging');
            }
            if (moved) this.track.scrollLeft = startLeft - distance;
          });

          const stop = (event) => {
            if (!active) return;
            active = false;
            this.track.classList.remove('is-dragging');
            if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          };
          this.track.addEventListener('pointerup', stop);
          this.track.addEventListener('pointercancel', stop);

          this.track.addEventListener(
            'click',
            (event) => {
              if (!moved) return;
              event.preventDefault();
              event.stopPropagation();
              moved = false;
            },
            true
          );
          this.track.addEventListener('dragstart', (event) => event.preventDefault());
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
